import { inject } from '@angular/core';
import { EgScreenContext, EgScreenResolver } from '@expertgroup/assistant';
import { CopyService } from '@/app/core/copy/copy.service';
import { UNKNOWN_SCREEN, resolveScreen } from './screen-registry';

/**
 * Kontekst ekrana za asistenta — registar ekrana prevodi adresu u ono što ide serveru (`uiContext`).
 *
 * Traka zove `resolve` na svakoj navigaciji (`NavigationEnd.urlAfterRedirects`) i rezultat daje i čipu u
 * zaglavlju i pitanju — jedan izvor, pa ne mogu da se raziđu.
 *
 * - `screenId` je id iz registra: stabilan, ASCII, nikad preveden. Oko njega se dogovaraju asistent i korpus.
 * - `screenName` je lokalizovano ime iz kopije (`screens.<id>`), na jeziku koji korisnik gleda.
 * - `route` je PUTANJA, bez query-ja i fragmenta. ⚠️ Ta vrednost ulazi u prompt; query danas u ProTax-u ne
 *   postoji, ali čim tabela počne da čuva filter u adresi (PIB, naziv pravnog lica), on bi bez ovog skidanja
 *   tiho otišao na server. Registar ih iz istog razloga ne gleda pri razrešavanju.
 *
 * Nepoznat ekran daje `null` — serveru tada ide `uiContext: null`, tačno kao da resolver-a nema. „Nepoznat
 * ekran" kao ime bi asistentu rekao manje od ničega.
 */
export function protaxScreenResolver(t: (key: string) => string): EgScreenResolver {
    return {
        resolve(url: string): EgScreenContext | null {
            const screen = resolveScreen(url);
            if (screen.id === UNKNOWN_SCREEN.id) return null;
            return { screenId: screen.id, screenName: t(screen.nameKey), route: url.split(/[?#]/)[0] };
        }
    };
}

/** Fabrika za `provideEgAssistantScreen` — izvršava se u kontekstu injektora, pa sme da traži `CopyService`. */
export function injectProtaxScreenResolver(): EgScreenResolver {
    return protaxScreenResolver(inject(CopyService).t);
}
